import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/report/taxReport' : '/report/taxReport'


// 添加四上报表对应企业
export function addSuperviseReportCompany(data) {
  return request({
    url: urlPrefix + '/addSuperviseReportCompany',
    method: 'post',
    data
  })
}

// 删除四上报表对应企业
export function deleteSuperviseReportCompany(id) {
  return request({
    url: urlPrefix + '/deleteSuperviseReportCompany?superviseReportCompanyId=' + id,
    method: 'post'
  })
}

// 查询四上报表对应企业
export function selectSuperviseReportCompanyByPage(data) {
  return request({
    url: urlPrefix + '/selectSuperviseReportCompanyByPage',
    method: 'post',
    data
  })
}

// 修改四上报表对应企业
export function updateSuperviseReportCompany(data) {
  return request({
    url: urlPrefix + '/updateSuperviseReportCompany',
    method: 'post',
    data
  })
}
